import React, { useState } from 'react'
import { Box, MenuItem, Select } from '@mui/material'
import { useActionOptions } from './TreeActions'
import { PotentiallyHtml } from '../../PotentiallyHtml'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { selectedNodeAtom } from './atoms'

// If there is a selected node this component will render the options menu
export function NodeView() {
  const selectedNode = useAtomValue(selectedNodeAtom)
  if (!selectedNode) return null

  return (
    <Box>
      <Box padding="5px">
        <strong>
          {`${selectedNode.type}: `}
          <PotentiallyHtml s={selectedNode.title} />
        </strong>
      </Box>
      <Box>{selectedNode.id}</Box>
      {selectedNode.body?.value && (
        <Box>
          <PotentiallyHtml s={selectedNode.body.value} />
        </Box>
      )}
      <ActionMenu />
    </Box>
  )
}

function ActionMenu() {
  const [currentAction, setCurrentAction] = useState('')
  const options = useActionOptions()

  if (!options.length) return null

  const Component = options.find(([key]) => key === currentAction)?.[1]
  return (
    <Box>
      <Box padding="5px">
        <Select
          value={currentAction}
          onChange={({ target: { value } }) => setCurrentAction(value)}
        >
          {options.map(([key]) => {
            return (
              <MenuItem key={key} value={key}>
                {key}
              </MenuItem>
            )
          })}
        </Select>
      </Box>
      {Component && (
        <Box padding="10px">
          <Component />
        </Box>
      )}
    </Box>
  )
}
